// Embargo helpers shared by the package card and the package details view.
//
// The backend serializes `UploadMetadata.embargo` as a Jackson `Instant`, which reaches
// the UI in whichever shape the mapper is configured for (epoch-seconds number, [seconds,
// nanos] array, or an ISO-8601 string) — `toDate` normalises all of them, so never call
// `new Date(value)` on an embargo directly.

import { toDate } from "./adminDates";

const EMBARGO_FORMATTER = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const EMBARGO_DATE_FORMATTER = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

/** The embargo as a Date, or null when the package has none / the value is unparseable. */
export const getEmbargoDate = (value) => toDate(value);

/**
 * True while the embargo has NOT passed yet — i.e. the package is still restricted.
 * A package with no embargo is never active.
 */
export const isEmbargoActive = (value, now = Date.now()) => {
  const date = toDate(value);
  return date ? date.getTime() > now : false;
};

/** Human-readable embargo, e.g. "3 Jul 2026, 14:30". Empty string when there is none. */
export const formatEmbargo = (value) => {
  const date = toDate(value);
  return date ? EMBARGO_FORMATTER.format(date) : "";
};

/**
 * Date-only embargo in dd.MM.yyyy, e.g. "29.08.2026" — short enough for the badge glued
 * to the package block. Empty string when there is none.
 */
export const formatEmbargoDate = (value) => {
  const date = toDate(value);
  return date ? EMBARGO_DATE_FORMATTER.format(date).replace(/\//g, ".") : "";
};
